import React from 'react';
import { Box } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { useStyles } from './ESignatureStyles';
import ESignatureForm from '../Forms/ESignatureForm';
import { Offline } from '../Common/Offline';
import Modal from './Modal';
import {
  clearEsignInfo,
  closeEsignModal,
} from '../../../legacy/store/appReducer';
import { useOnline } from '../../../hooks';

/**
 * E-Signature Modal
 * @param {Boolean} open : Condition for open modal (true/false)
 * @param {Function} confirmHandler : Function to be exectued on confirm
 * @param {String} formTitle : Title of esignaure form
 * @param {String} screenName : Name of the screen whre the modal is getting redered
 */
function ESignatureModal(props) {
  const classes = useStyles();
  const isOnline = useOnline();

  const { open, confirmHandler, formTitle, screenName } = props;
  const dispatch = useDispatch();

  // close modal handle to update the redux state on close
  const closeModalHandler = () => {
    dispatch(closeEsignModal());
  };

  // updating the redux state - esign modal state on component unmount
  React.useEffect(() => {
    return () => {
      dispatch(clearEsignInfo());
    };
  }, []);

  return (
    <Modal
      className={classes.modal}
      showModal={open}
      onClose={closeModalHandler}
      title={<FormattedMessage id="label.esign" />}
      hideCloseButtonLabel
    >
      <Box className={classes.body}>
        {isOnline ? (
          <ESignatureForm
            title={formTitle}
            onCancel={closeModalHandler}
            onSubmit={confirmHandler}
            screenName={screenName}
          />
        ) : (
          <Offline />
        )}
      </Box>
    </Modal>
  );
}

export default ESignatureModal;



// WEBPACK FOOTER //
// ./src/views/components/Modal/ESignatureModal.jsx